var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecreaseSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5623_57939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6154 3.69231V4.61538H8.30769C8.0631 4.61465 7.82874 4.51716 7.65578 4.34421C7.48283 4.17126 7.38535 3.9369 7.38462 3.69231V1.38462H8.30769V2.81539L11.5385 0L12 0.923077L8.81538 3.69231H10.6154ZM3.69231 9.18461L0.461538 12L0 11.0769L3.18462 8.30769H1.38462V7.38462H3.69231C3.9369 7.38535 4.17126 7.48284 4.34422 7.65579C4.51717 7.82874 4.61465 8.0631 4.61538 8.30769V10.6154H3.69231V9.18461ZM3.69231 4.61538H1.38462V3.69231H3.18462L0 0.923077L0.461538 0L3.69231 2.81539V1.38462H4.61538V3.69231C4.61465 3.9369 4.51717 4.17126 4.34422 4.34421C4.17126 4.51716 3.9369 4.61465 3.69231 4.61538ZM8.30769 7.38462H10.6154V8.30769H8.81538L12 11.0769L11.5385 12L8.30769 9.18461V10.6154H7.38462V8.30769C7.38535 8.0631 7.48283 7.82874 7.65578 7.65579C7.82874 7.48284 8.0631 7.38535 8.30769 7.38462Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5623_57939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseSize);
export default __webpack_public_path__ + "static/media/decrease_size.ac0bfeb6.svg";
export { ForwardRef as ReactComponent };